'use client';

import { useDataLayerEventOnPageLoad } from '@coolblue-development/next-analytics/client';
import { PageType } from '@sharedTypes';

type Props = {
  vacancyTitle: string;
  pageType: PageType;
  vacancyId: string;
  postingId?: string;
  departments: string[];
};

export const VacancyAnalyticsConfig = ({
  vacancyTitle,
  pageType,
  vacancyId,
  postingId,
  departments
}: Props) => {
  const event = [
    {
      vacancyTitle: vacancyTitle,
      pagetype: pageType,
      cbVacancyID: vacancyId,
      postingID: postingId,
      department: getFormattedDepartment(departments[0] ?? '')
    }
  ];

  useDataLayerEventOnPageLoad(event);

  return <></>;
};

const getFormattedDepartment = (department: string) => {
  return department
    .toLowerCase()
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
